/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { FunctionComponent } from 'react';

export interface CKIconStackProps {
  base: React.ReactNode;
  badge?: React.ReactNode;
}

export const CKIconStack: FunctionComponent<CKIconStackProps> = ({
  base,
  badge,
}) => {
  return (
    <div
      css={css`
        display: inline-flex;
        position: relative;
      `}
    >
      <div style={{ zIndex: 0 }}>{base}</div>
      {badge && (
        <div
          css={css`
            position: absolute;
            z-index: 1;
            top: -4px;
            right: -6px;
            background-color: white;
            border-radius: 100%;
            width: 16px;
            height: 16px;
            padding: 1px;
            svg {
              height: 100%;
              width: 100%;
            }
          `}
        >
          {badge}
        </div>
      )}
    </div>
  );
};
